import { Redirect } from 'react-router-dom';

import { ROUTES } from '~/routes';
import { useAuthStore } from '~/stores/auth';

interface RequireAuthProps {
  children: React.ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps): JSX.Element {
  const accessToken = useAuthStore((state) => state.accessToken);
  const isHydrated = useAuthStore((state) => state.isHydrated);

  if (!isHydrated) {
    return <></>;
  }

  if (!accessToken) {
    return <Redirect to={ROUTES.login} />;
  }

  return <>{children}</>;
}
